import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root"
})
export class MicrositeDataService {
	private basePath: string = `${environment.url}/api/Microsite/`;

	constructor(private http: HttpClient) {}

	checkDuplicateRequest(request: CheckDuplicateRequest) {
		return this.http.post<CheckDuplicateResponse>(
			`${this.basePath}CheckDuplicateRequest`,
			request
		);
	}
}

export interface CheckDuplicateRequest {
	vehicleNo: string;
	identityNo: string;
	email: string;
	mobileNo: string;
	postcode: string;
	eHailingUsed: boolean;
	preferredChannel: string;
}

export interface CheckDuplicateResponse {
	isExist: "Y" | "N";
	isLinkExist: "Y" | "N";
}
